import React from "react";

interface SkeletonProps {
  className?: string;
  children?: React.ReactNode;
}

export const Skeleton = ({ className = "", children }: SkeletonProps) => {
  return (
    <div className={`animate-pulse rounded-md bg-white/20 ${className}`}>
      {children}
    </div>
  );
};

export const ButtonSkeleton = ({ className = "", children }: SkeletonProps) => {
  return (
    <div className={`w-full h-full animate-pulse ${className}`}>
      <div className=" bg-black" />
      {children}
    </div>
  );
};
